package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_05_19_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes who are waking up in the barracks in Ket. As they approach the entrance to the Malusian Imperial Darkway, a group of soldiers are exiting, heading west.  The Darkway is carved into the area’s granite-like mountains. The tunnel is supported by both heavy wooden beams and stonework and is lit by well-attended torchlight. After the soldiers pass, our heroes can hear the sound of running water and occasionally the sound of small birds or bats’ wings flapping.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Around midday our heroes reach a guard outpost carved into the rock face.")
    }
}
